export default __webpack_public_path__ + "startups.49ca598b.png";